import React from 'react';
import './styles.css';
const orderSucces = "/assets/images/order_success.gif"

const OrderConfirmation = ({
  orderRef,
  title = "Your order is on its way!",
  bannerImage,
  initial = "J"
}) => {
  return (
    <div className="order-confirmation-container">
      {/* Banner / Illustration */}
      <div className="illustration-wrapper">
        {orderSucces ? (
          <img src={orderSucces} alt="Delivery Illustration" className="banner-image" />
        ) : (
          /* SVG Representation of City Skyline + Delivery Van */
          <svg
            className="default-banner-svg"
            viewBox="0 0 800 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {orderSucces}
          </svg>
        )}
      </div>

      {/* Content */}
      <div className="order-confirmation-content">
        <h2 className="order-confirmation-title">{title}</h2>
        <p className="order-confirmation-text">
          We’ll send an order confirmation to your billing email shortly. Your order
          reference number is <strong>{orderRef}</strong>.
        </p>
      </div>
    </div>
  );
};

export default OrderConfirmation;